import { BEACON_URL } from '@/config';

export const BEACON_INDIVIDUALS_PATH = '/individuals';
export const BEACON_FILTERING_TERMS_PATH = '/filtering_terms';
export const BEACON_OVERVIEW_PATH = '/overview';

// add scope.. currently node-level only but will change without notice
export const BEACON_INFO_ENDPOINT = BEACON_URL + '/overview';
